import {
	GET_REVISION,
	GET_REVISION_SUCCESS,
	GET_REVISION_FAIL,
	GET_REVISION_RESET,
} from '../actions/getRevisionAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getRevisionReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_REVISION:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_REVISION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_REVISION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_REVISION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getRevisionReducer;
